<span class="dot-locked"><mat-icon class="lock">lock</mat-icon></span>
